import { captureReferralDataFromQueryParams, getReferralData, mapParamsByConfig, parseQueryString } from './helpers'
import { PrivateRoute } from './privateRoute';
import { mapping, errorRoute } from './routing-servercodes-mapping';

export default {
    captureReferralDataFromQueryParams,
    getReferralData,
    mapParamsByConfig,
    parseQueryString,
    PrivateRoute,
    mapping,
    errorRoute
};
